import { render } from "./footer-reg.vue?vue&type=template&id=0b64baab"
import script from "./footer-reg.vue?vue&type=script&lang=js"
export * from "./footer-reg.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__